export default {
  path: ['/wecode/:type/feedbackEdit'],
  auth: true,
  preload: false,
  key: 'feedback',
  layout: 'outer', // outer 一级菜单 inner 二级菜单
  component: (props) => import('./index')
};
